var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFluxPlusLogo = function SvgFluxPlusLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 79 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC109",
    d: "M13.2135 9.229H4.09277V11.7404H13.2135V9.229ZM62.9718 0H60.1597L56.0464 6.93806 57.4539 9.30662 62.9718 0ZM2.38714 0H0V22H2.38714V0ZM18.3359 0H15.9487V22H18.3359V0ZM13.2135 0H4.09277V2.51136H13.2135V0ZM73.2372 0H70.8501V14.6398H73.2372V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC109",
    d: "M79.0001 6.06577H65.0845V8.57712H79.0001V6.06577ZM47.1113 21.9969H49.9263L54.0367 15.0681 52.6292 12.6965 47.1113 21.9969ZM29.1593 19.4886H20.0386V22H29.1593V19.4886ZM49.9204 0H47.1084L60.1595 21.9969H62.9745L49.9204 0ZM42.3845 14.7888C42.3845 17.3839 40.3839 19.4886 37.9171 19.4886H37.7696C35.3028 19.4886 33.3022 17.3839 33.3022 14.7888V0H30.915V14.7888C30.915 18.7716 33.9838 22 37.7696 22H37.9171C41.7029 22 44.7717 18.7716 44.7717 14.7888V0H42.3845V14.7888Z"
  })));
};
export default SvgFluxPlusLogo;